import { z } from 'zod';
/**
 * The search box in the top bar (Ctrl+K): one query across every kind of
 * record, in every book of the organisation the person is working in.
 *
 * Two characters before anything is asked - one matches half the database and
 * tells nobody anything - and a hundred at most, because nobody types a
 * paragraph into a search box and a long string is only ever a paste.
 */
export const globalSearchQuerySchema = z
    .object({
    q: z.string().trim().min(2, 'Type at least two characters').max(100),
    /** Every book in the organisation (the default), or just the one open. */
    scope: z.enum(['organisation', 'book']).default('organisation'),
    /** Per kind of record, per book: 6 under the search bar, up to 50 on the results page. */
    limit: z.coerce.number().int().min(1).max(50).default(6),
})
    .strict();
/** In the order the results are grouped on screen. */
export const SEARCH_RESULT_TYPES = [
    'invoice',
    'proforma',
    'customer',
    'vendor',
    'payment',
    'expense',
    'bank_transaction',
    'item',
    'project',
];
//# sourceMappingURL=search.js.map